module.exports = __webpack_public_path__ + "img/1540598288.50486b26.jpg";